<script>
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import 'xterm/css/xterm.css'
import { mapState, mapActions, mapMutations } from 'vuex'
import axios from 'axios'

export default {
   name: 'ScrapRun',
   components: {},
   data() {
      return {
         pageList: 1,
         totalPage: 0,
         grandTotal: 0,
         request: null,
         term: null,
         fitAddon: null,
      }
   },
   computed: {
      ...mapState({
         myData: state => state.SimbgScrap24.data,
         myCount: state => state.SimbgScrap24.countAll,
         myCountDetail: state => state.SimbgScrap24.countAllDetail,
         myCurrent: state => state.SimbgScrap24.current,
         mySuccess: state => state.SimbgScrap24.success,
         myFailed: state => state.SimbgScrap24.failed,
         myState: state => state.SimbgScrap24.runningState,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
      current: {
         get() {
            return this.myCurrent
         },
         set(value) {
            let newVal

            if (value) {
               newVal = value
            } else {
               newVal = 0
            }

            this.updateCurrent(parseInt(newVal, 10))
         },
      },
   },
   watch: {
      // isLoading(val) {
      //    if (val) {
      //       this.$swal({ text: 'Loading', allowOutsideClick: false })
      //       this.$swal.showLoading()
      //    } else {
      //       this.$swal.close()
      //    }
      // },
   },
   mounted() {
      // 1. Inisialisasi Terminal
      this.term = new Terminal({
         cursorBlink: true,
         fontSize: 14,
         fontFamily: 'Consolas, "Courier New", monospace',
         theme: {
            background: '#021a23',
            foreground: '#d4d4d4',
         },
      })
      // 2. Load Addon Fit
      this.fitAddon = new FitAddon()
      this.term.loadAddon(this.fitAddon)

      // 3. Pasang Terminal ke elemen DOM
      this.term.open(this.$refs.terminalContainer)

      // 4. Sesuaikan ukuran awal
      this.fitAddon.fit()

      // Tulis pesan sambutan
      // this.term.write('Xterm.js siap di Vue 2!\n\r')
      // this.term.write('$ ')

      // 5. Tambahkan Event Listener (jika Anda butuh input interaktif)
      this.term.onData(data => {
      // Anda dapat mengirim 'data' ini ke backend (misalnya melalui Socket.io atau API)
         this.term.write(data)
         if (data === '\r') {
            this.term.write('\n\r[Command received]\n\r$ ')
         }
      })

      window.addEventListener('resize', this.handleResize)

      this.onLoadList()
   },
   beforeDestroy() {
      // 6. Bersihkan (Dispose) Terminal
      // Ini sangat penting untuk mencegah memory leak di Vue 2
      window.removeEventListener('resize', this.handleResize)
      if (this.term) {
         this.term.dispose()
      }
   },
   methods: {
      ...mapActions({
         getData: 'SimbgScrap24/getData',
         getDataError: 'SimbgScrap24/getDataError',
         runScrap: 'SimbgScrap24/runScrap',
         loginSimbg: 'SimbgScrap24/loginSimbg',
         runScrapList: 'SimbgScrap24/runScrapList',
      }),
      ...mapMutations({
         updateCurrent: 'SimbgScrap24/SET_CURRENT',
         setState: 'SimbgScrap24/SET_STATE',
         setCancelToken: 'SimbgScrap24/SET_CANCEL_TOKEN',
         setReset: 'SimbgScrap24/SET_RESET',
      }),
      run() {
         if (!this.myState) {
            return
         }

         // console.log(this.myData[this.myCurrent].uid)

         this.write(`Run ${this.myCurrent}`)
         this.write(`------ Body : { uid : ${JSON.stringify(this.myData[this.myCurrent].uid)}}`)

         this.runScrap(this.myData[this.myCurrent].uid).then(
            data => {
               if (data?.data) {
                  this.write(`------ Response : \x1B[1;3;32m${JSON.stringify(data.data)}\x1B[0m `)
               } else {
                  // Jika request gagal, tampilkan pesan error + body response dari server (jika ada)
                  const errMessage = [
                  data?.message,
                  data?.response?.data ? JSON.stringify(data.response.data) : null,
                  ].filter(Boolean).join(' | ')

                  this.write(`------ Response : \x1B[1;3;31m${errMessage || JSON.stringify(data)}\x1B[0m `)
               }

               if (this.myCurrent < this.myCount) {
                  this.run()
               } else {
                  this.setState(false)
               }
            },
            () => {
               this.run()
            },
         )
      },
      onStart() {
         this.write('Start Run')
         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)
         this.run()
      },
      onStop() {
         this.write('\x1B[1;3;31mStop\x1B[0m')
         this.setState(false)
         this.request.cancel()
      },
      onRunList() {
         this.write('Start : Update List Permohonan')
         this.write(`------ Page : ${this.pageList}`)

         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)

         this.loading = true
         this.runScrapList(this.pageList).then(
            res => {
               this.totalPage = res.total_page
               this.grandTotal += res.total_item
               this.write(`------ Item : ${res.total_item}`)
               this.write(`------ Total : ${this.grandTotal}`)
               this.pageList = parseInt(this.pageList, 10) + 1

               // this.$toast.success(res.message)
               this.loading = false

               // console.log(this.pageList, this.totalPage)
               if (this.pageList > this.totalPage) {
                  this.write('Finish : Update List Permohonan')
                  this.getData()
                  this.pageList = 1
                  this.totalPage = 0
                  this.grandTotal = 0
                  this.setState(false)
               } else {
                  this.onRunList()
               }
            },
            () => {
               this.write('------ \x1B[1;3;31mGagal mendapatkan list permohonan\x1B[0m')
               this.loading = false
            },
         )
      },
      onLoadList() {
         this.setReset()
         this.write('Start : Load list')
         this.getData()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLoadListError() {
         this.setReset()
         this.write('Start : Load list error only')
         this.getDataError()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLogin() {
         this.write('Login')
         this.loading = true
         this.loginSimbg().then(
            res => {
               this.write(`------ ${res.message}`)
               this.$toast.success(res.message)
               this.loading = false
            },
            () => {
               this.write('------ Gagal Login')
               this.loading = false
            },
         )
      },
      write(text) {
         if (this.term) {
            this.term.write(`${text}\n\r`)
         }
      },
      handleResize() {
         if (this.fitAddon) {
            this.fitAddon.fit()
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12" xl="4" lg="4" md="4">
         <b-card title="Jumlah">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="DollarSignIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCountDetail }}
                        </h5>
                        <small>Total PBG/SLF (yang berhasil ditarik)</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCount }}
                        </h5>
                        <small>Total PBG/SLF List</small>
                     </div>
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Status">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="DollarSignIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCurrent }}
                        </h5>
                        <small>Current / Posisi</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-success" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ mySuccess }}
                        </h5>
                        <small>Sukses</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-danger" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myFailed }}
                        </h5>
                        <small>Error</small>
                     </div>
                  </div>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-form-input v-model="current" :disabled="myState" type="number" placeholder="Enter Posisi" />
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="isLoading" variant="secondary" block @click="onStart">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Start
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="!myState" variant="danger" block @click="onStop">
                     Stop
                  </b-button>
               </b-col>
               <hr>
               <b-col md="12" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLogin">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Login
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadList()">
                     Load All
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadListError()">
                     Load Error Only
                  </b-button>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Update List Permohonan">
            <b-row>
               <b-col md="12" class="mb-1">
                  <b-form-input
                     v-model="pageList"
                     :disabled="isLoading"
                     type="number"
                     placeholder="Page"
                     label="Page"
                  />
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="isLoading" variant="secondary" block @click="onRunList">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Update List Permohonan
                  </b-button>
               </b-col>
            </b-row>
         </b-card>
      </b-col>
      <b-col cols="12" md="8" xl="8" lg="8">
         <b-card title="Action">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <b-progress
                        :value="myCurrent"
                        :max="myCount"
                        precision="2"
                        show-progress
                        variant="primary"
                        class="progress-bar-warning"
                     />
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Logs">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <div id="terminal-container" ref="terminalContainer" />
                  </div>
               </b-col>
            </b-row>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
#terminal-container {
  /* Berikan dimensi yang jelas pada kontainer */
  width: 100%;
  height: 400px;
  border: 1px solid #555;
  padding: 5px;
}
</style>
